export default "__VITE_ASSET__DjmVf9CL__"